<template>
  <div class="hero-section">
    <!-- 蓝图网格背景 -->
    <div class="blueprint-grid"></div>
    
    <!-- 建筑剪影层 -->
    <div class="cityscape-layer">
      <svg viewBox="0 0 1440 300" preserveAspectRatio="none" class="cityscape-svg">
        <!-- 远处建筑群 -->
        <rect x="0" y="180" width="80" height="120" fill="rgba(255,255,255,0.04)" />
        <rect x="60" y="150" width="60" height="150" fill="rgba(255,255,255,0.05)" />
        <rect x="140" y="200" width="100" height="100" fill="rgba(255,255,255,0.04)" />
        <rect x="200" y="160" width="50" height="140" fill="rgba(255,255,255,0.06)" />
        <rect x="280" y="120" width="70" height="180" fill="rgba(255,255,255,0.05)" />
        <rect x="330" y="190" width="60" height="110" fill="rgba(255,255,255,0.04)" />
        <!-- 近处建筑 -->
        <rect x="400" y="90" width="90" height="210" fill="rgba(255,255,255,0.07)" />
        <rect x="520" y="140" width="80" height="160" fill="rgba(255,255,255,0.06)" />
        <rect x="570" y="80" width="60" height="220" fill="rgba(255,255,255,0.08)" />
        <rect x="650" y="170" width="100" height="130" fill="rgba(255,255,255,0.05)" />
        <rect x="780" y="100" width="70" height="200" fill="rgba(255,255,255,0.07)" />
        <rect x="830" y="150" width="90" height="150" fill="rgba(255,255,255,0.06)" />
        <rect x="940" y="60" width="80" height="240" fill="rgba(255,255,255,0.08)" />
        <rect x="1000" y="130" width="70" height="170" fill="rgba(255,255,255,0.06)" />
        <rect x="1100" y="180" width="100" height="120" fill="rgba(255,255,255,0.05)" />
        <rect x="1180" y="70" width="60" height="230" fill="rgba(255,255,255,0.07)" />
        <rect x="1260" y="160" width="80" height="140" fill="rgba(255,255,255,0.05)" />
        <rect x="1340" y="130" width="100" height="170" fill="rgba(255,255,255,0.04)" />
        <!-- 建筑窗户点缀 -->
        <g opacity="0.15">
          <rect x="420" y="110" width="6" height="6" fill="#fff" rx="1" />
          <rect x="435" y="110" width="6" height="6" fill="#fff" rx="1" />
          <rect x="420" y="125" width="6" height="6" fill="#fff" rx="1" />
          <rect x="450" y="110" width="6" height="6" fill="#fff" rx="1" />
          <rect x="435" y="125" width="6" height="6" fill="#fff" rx="1" />
          <rect x="455" y="140" width="6" height="6" fill="#fff" rx="1" />
          <rect x="580" y="100" width="6" height="6" fill="#fff" rx="1" />
          <rect x="600" y="100" width="6" height="6" fill="#fff" rx="1" />
          <rect x="580" y="115" width="6" height="6" fill="#fff" rx="1" />
          <rect x="800" y="120" width="6" height="6" fill="#fff" rx="1" />
          <rect x="815" y="120" width="6" height="6" fill="#fff" rx="1" />
          <rect x="960" y="80" width="6" height="6" fill="#fff" rx="1" />
          <rect x="975" y="80" width="6" height="6" fill="#fff" rx="1" />
          <rect x="960" y="95" width="6" height="6" fill="#fff" rx="1" />
          <rect x="990" y="80" width="6" height="6" fill="#fff" rx="1" />
          <rect x="1200" y="90" width="6" height="6" fill="#fff" rx="1" />
          <rect x="1215" y="90" width="6" height="6" fill="#fff" rx="1" />
        </g>
      </svg>
    </div>

    <!-- 塔吊装饰（右上） -->
    <div class="crane-decoration">
      <svg viewBox="0 0 100 200" width="100" height="200">
        <line x1="50" y1="20" x2="50" y2="200" stroke="rgba(255,255,255,0.12)" stroke-width="3" />
        <line x1="50" y1="20" x2="100" y2="20" stroke="rgba(255,255,255,0.12)" stroke-width="3" />
        <line x1="50" y1="50" x2="100" y2="20" stroke="rgba(255,255,255,0.06)" stroke-width="1" stroke-dasharray="4,4" />
        <line x1="100" y1="20" x2="100" y2="60" stroke="rgba(255,255,255,0.08)" stroke-width="1" />
        <circle cx="100" cy="65" r="4" fill="rgba(255,255,255,0.1)" />
        <line x1="60" y1="20" x2="80" y2="40" stroke="rgba(255,255,255,0.06)" stroke-width="1" stroke-dasharray="3,3" />
      </svg>
    </div>

    <div class="wrap">
      <div class="hero-content">
        <!-- 左侧文字 -->
        <div class="hero-left">
          <div class="hero-main-title">
            <h1 class="hero-title-cn">二级建造师</h1>
            <div class="hero-title-line">
              <span class="hero-title-sub">继续教育在线学习平台</span>
            </div>
          </div>

          <p class="hero-description">
            面向二级建造师的企业级继续教育在线学习服务，涵盖建筑工程、市政公用、机电工程、矿业工程、公路工程、水利工程六大专业方向，必修选修全覆盖。
          </p>

          <div class="hero-features">
            <div class="feature-item">
              <div class="feature-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
              </div>
              <span>在线学习</span>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
              </div>
              <span>学时认定</span>
            </div>
            <div class="feature-item">
              <div class="feature-icon">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2"><rect x="3" y="3" width="18" height="18" rx="3"/><line x1="3" y1="9" x2="21" y2="9"/></svg>
              </div>
              <span>证书管理</span>
            </div>
          </div>

          <div class="hero-actions">
            <button class="btn-primary" @click="goRegister">立即报名学习</button>
            <button class="btn-outline" @click="goLearningProcess">了解学习流程</button>
          </div>
        </div>

        <!-- 右侧建筑配图区 -->
        <div class="hero-right">
          <div class="buildings-group">
            <div class="building bld-1">
              <div class="bld-body">
                <div class="bld-window-row" v-for="r in 5" :key="'w1-'+r">
                  <span class="bld-window" v-for="c in 3" :key="'w1-'+r+'-'+c"></span>
                </div>
              </div>
              <div class="bld-roof"></div>
            </div>
            <div class="building bld-2">
              <div class="bld-body">
                <div class="bld-window-row" v-for="r in 6" :key="'w2-'+r">
                  <span class="bld-window" v-for="c in 4" :key="'w2-'+r+'-'+c"></span>
                </div>
              </div>
              <div class="bld-ant"></div>
            </div>
            <div class="building bld-3">
              <div class="bld-body">
                <div class="bld-window-row" v-for="r in 4" :key="'w3-'+r">
                  <span class="bld-window" v-for="c in 2" :key="'w3-'+r+'-'+c"></span>
                </div>
              </div>
              <div class="bld-roof"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部波浪过渡 -->
    <div class="hero-wave">
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
        <path d="M0,50 C240,90 480,90 720,50 C960,10 1200,10 1440,50 L1440,80 L0,80 Z" fill="#f5f7fa"></path>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "hero-section",
  methods: {
    goRegister() {
      let routeData = this.$router.resolve({ name: "register" });
      window.open(routeData.href, "_blank");
    },
    goLearningProcess() {
      this.$router.push({ path: "/learningProcess" });
    },
  },
};
</script>

<style scoped lang="scss">
.hero-section {
  position: relative;
  width: 100%;
  min-height: 460px;
  background: linear-gradient(160deg, #1565C0 0%, #1976D2 30%, #42A5F5 60%, #64B5F6 100%);
  overflow: hidden;
  display: flex;
  align-items: center;
  isolation: isolate;
}

// ============ 蓝图网格 ============
.blueprint-grid {
  position: absolute;
  inset: 0;
  background-image: 
    linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
  background-size: 60px 60px;
  background-position: center center;
  pointer-events: none;
  z-index: 0;

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    background: 
      radial-gradient(ellipse at 80% 20%, rgba(66, 165, 245, 0.08) 0%, transparent 50%),
      radial-gradient(ellipse at 20% 80%, rgba(13, 71, 161, 0.1) 0%, transparent 50%);
  }
}

// ============ 建筑剪影层 ============
.cityscape-layer {
  position: absolute;
  bottom: 60px;
  left: 0;
  width: 100%;
  z-index: 0;
  pointer-events: none;

  .cityscape-svg {
    width: 100%;
    height: auto;
    display: block;
  }
}

// ============ 塔吊装饰 ============
.crane-decoration {
  position: absolute;
  right: -10px;
  top: 20px;
  z-index: 1;
  pointer-events: none;
  opacity: 0.5;

  @media (max-width: 992px) { display: none; }
}

// ============ 内容区 ============
.hero-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
  z-index: 2;
}

.hero-left {
  flex: 1;
  max-width: 620px;
  padding: 20px 0;
}

.hero-main-title {
  margin-bottom: 20px;

  .hero-title-cn {
    font-size: 46px;
    font-weight: 800;
    color: #fff;
    margin: 0 0 8px;
    line-height: 1.15;
    letter-spacing: 6px;
  }

  .hero-title-line {
    display: flex;
    align-items: center;
    gap: 0;

    .hero-title-sub {
      font-size: 22px;
      font-weight: 400;
      color: rgba(255,255,255,0.85);
      margin: 0;
      letter-spacing: 4px;
    }

    &::before {
      content: '';
      width: 40px;
      height: 2px;
      background: rgba(255,255,255,0.4);
      margin-right: 16px;
    }
  }
}

.hero-description {
  font-size: 14px;
  color: rgba(255,255,255,0.7);
  line-height: 1.9;
  margin-bottom: 24px;
  max-width: 540px;
}

.hero-features {
  display: flex;
  gap: 30px;
  margin-bottom: 30px;

  .feature-item {
    display: flex;
    align-items: center;
    gap: 8px;
    color: rgba(255,255,255,0.8);
    font-size: 13px;
    letter-spacing: 1px;

    .feature-icon {
      width: 32px;
      height: 32px;
      border-radius: 8px;
      background: rgba(255,255,255,0.1);
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border: 1px solid rgba(255,255,255,0.12);
    }
  }
}

.hero-actions {
  display: flex;
  align-items: center;
  gap: 16px;

  .btn-primary {
    padding: 13px 36px;
    background: #fff;
    color: #42A5F5;
    border: none;
    border-radius: 4px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    letter-spacing: 2px;
    transition: all 0.25s;
    box-shadow: 0 4px 16px rgba(0,0,0,0.12);

    &:hover {
      background: #E3F2FD;
      box-shadow: 0 6px 24px rgba(0,0,0,0.18);
      transform: translateY(-1px);
    }
  }

  .btn-outline {
    padding: 13px 28px;
    background: transparent;
    color: #fff;
    border: 1px solid rgba(255,255,255,0.4);
    border-radius: 4px;
    font-size: 15px;
    font-weight: 400;
    cursor: pointer;
    letter-spacing: 2px;
    transition: all 0.25s;

    &:hover {
      border-color: #fff;
      background: rgba(255,255,255,0.08);
      transform: translateY(-1px);
    }
  }
}

// ============ 右侧建筑群 ============
.hero-right {
  flex: 0 0 360px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-left: 40px;
}

.buildings-group {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  height: 280px;
}

.building {
  border-radius: 6px 6px 0 0;
  overflow: hidden;

  .bld-body {
    padding: 10px 8px 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .bld-window-row {
    display: flex;
    gap: 3px;
    justify-content: center;
  }

  .bld-window {
    width: 8px;
    height: 10px;
    background: rgba(255,255,255,0.12);
    border-radius: 1px;
    transition: background 0.3s;

    &:nth-child(odd) {
      background: rgba(255,255,255,0.2);
    }
  }

  &:hover .bld-window {
    background: rgba(255,255,255,0.35);
    &:nth-child(even) { background: rgba(255,255,255,0.15); }
  }

  &.bld-1 {
    width: 90px;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,255,255,0.08);
    height: 220px;

    .bld-roof {
      height: 16px;
      background: rgba(255,255,255,0.08);
    }
  }

  &.bld-2 {
    width: 110px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.1);
    height: 260px;
    position: relative;

    .bld-ant {
      position: absolute;
      top: -40px;
      left: 50%;
      transform: translateX(-50%);
      width: 3px;
      height: 40px;
      background: rgba(255,255,255,0.15);
    }
  }

  &.bld-3 {
    width: 70px;
    background: rgba(255,255,255,0.05);
    border: 1px solid rgba(255,255,255,0.06);
    height: 180px;

    .bld-roof {
      height: 12px;
      background: rgba(255,255,255,0.06);
    }
  }
}

// ============ 波浪 ============
.hero-wave {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 80px;
  z-index: 2;
  pointer-events: none;

  svg { width: 100%; height: 100%; }
}

// ============ 响应式 ============
@media (max-width: 992px) {
  .hero-right { display: none; }
  .hero-left { max-width: 100%; text-align: center; }
  .hero-features { justify-content: center; }
  .hero-actions { justify-content: center; }
  .hero-description { max-width: 100%; margin-left: auto; margin-right: auto; }

  .hero-main-title .hero-title-cn { font-size: 36px; letter-spacing: 3px; }
  .hero-main-title .hero-title-line { justify-content: center; }
  .hero-main-title .hero-title-line::before { display: none; }
  .hero-main-title .hero-title-sub { font-size: 18px; letter-spacing: 2px; }
}

@media (max-width: 600px) {
  .hero-section { min-height: 400px; padding-top: 52px; }
  .hero-main-title .hero-title-cn { font-size: 26px; }
  .hero-main-title .hero-title-sub { font-size: 15px; }
  .hero-description { font-size: 12px; }
  .hero-features { flex-direction: column; align-items: center; gap: 12px; }
  .hero-actions { flex-direction: column; width: 100%; 
    .btn-primary, .btn-outline { width: 100%; text-align: center; justify-content: center; }
  }
}
</style>
